/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const listTypesParamsFirstExclusiveMin = 0;
export const listTypesParamsFirstMax = 500;

export const listTypesParamsOffsetMin = 0;

export const ListTypesParams = zod.object({
  viewActorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  kind: zod.enum(['complex', 'primitive', 'all']).optional(),
  instantiable: zod.union([zod.enum(['true']), zod.enum(['false']), zod.boolean()]).optional(),
  searchTerm: zod.string().optional(),
  first: zod.int().gt(listTypesParamsFirstExclusiveMin).max(listTypesParamsFirstMax).optional(),
  offset: zod.int().min(listTypesParamsOffsetMin).nullish(),
});

export type ListTypesParams = zod.input<typeof ListTypesParams>;
export type ListTypesParamsOutput = zod.output<typeof ListTypesParams>;
